import { defineComponent, h, nextTick } from 'vue';
import { QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
//import combo from '../3rdParty/Combo.jsx';
//import combo from '../vuecontrols/combobox.jsx';
//import ResizeObserver from '../3rdParty/ResizeObserver.jsx';
import AceEditor from '../3rdParty/AceEditor.jsx';

const booleanOptions = [{ text: 'true', value: true }, { text: 'false', value: false }];

export default defineComponent({
    name: 'form-boolean',
    components: {
        QSelect,
        AceEditor
    },
    data: function () {
        return {
            asjson: false,
            uniquekey: null,
            rawJsonEditorHeight: '100px',
        }
    },
    created() {
        this.uniquekey = utils.generateUUID();
    },
    mounted() {
        nextTick(() => this.ensureRawJsonAceResizeObserver());
    },
    updated() {
        nextTick(() => this.ensureRawJsonAceResizeObserver());
    },
    beforeUnmount() {
        this.teardownRawJsonAceResizeObserver();
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        ensureRawJsonAceResizeObserver() {
            if (typeof ResizeObserver === 'undefined')
                return;
            const host = this.$refs.booleanRawJsonAceHost;
            if (!host) {
                this.teardownRawJsonAceResizeObserver();
                return;
            }
            if (this._booleanRawJsonResizeObserved === host)
                return;
            this.teardownRawJsonAceResizeObserver();
            this._booleanRawJsonResizeObserved = host;
            this._booleanRawJsonResizeObserver = new ResizeObserver(() => {
                const px = Math.round(host.offsetHeight || 0);
                if (!px)
                    return;
                const next = `${px}px`;
                if (this.rawJsonEditorHeight !== next)
                    this.rawJsonEditorHeight = next;
            });
            this._booleanRawJsonResizeObserver.observe(host);
        },
        teardownRawJsonAceResizeObserver() {
            if (this._booleanRawJsonResizeObserver) {
                this._booleanRawJsonResizeObserver.disconnect();
                this._booleanRawJsonResizeObserver = null;
            }
            this._booleanRawJsonResizeObserved = null;
        },
        //resize() {
        //    this.sel_height = this.$refs.app.clientHeight;
        //    this.sel_width = this.$refs.app.clientWidth;
        //    utils.log('boolean resize: sel_height: ' + this.sel_height + ', sel_width: ' + this.sel_width);
        //},
        sync(prop, value) {
            let v = value;
            if (!this.useexpressions)
                // Convert true and false to actual boolean values
                if (v == 'false') v = false; else if (v == 'true') v = true;

            this.cmodel[prop] = v;
        },
        sync_json(text) {
            try {
                this.cmodel[this.schemakey] = JSON.parse(text);
            }
            catch (e) {
                utils.warn('boolean in propertygrid could not parse JSON', e);
            }
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        readonly: false,
        child: 0,
        useexpressions: false,
        propertygrid: false,
    },
    render() {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "var(--v-checkboxGrey-base)", fontSize: "small", marginLeft: "3px" }}></i>;

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;
        let input;

        const jsonico = this.asjson ? <i class="mdi mdi-eye-off" title="JSON view"></i> : <i class="mdi mdi-eye" title="JSON view"></i>;
        const jsontgl = <span style={{ fontSize: "smaller", cursor: "pointer", color: "gray" }} onClick={() => this.asjson = !this.asjson}>{jsonico}</span>;

        if (this.asjson || typeof this.cmodel[this.schemakey] === 'string') {
            // Allows viewing/editing the raw JSON of the element model
            const rawjson = JSON.stringify(this.cmodel[this.schemakey], null, 4);
            return (
                <tr class="pa-0 ma-0">
                    <td style={{ width: "1px", verticalAlign: "top", whiteSpace: "nowrap", paddingTop: "6px" }}>
                        {name} {jsontgl} {desc}
                    </td>

                    <td style={{ width: "100%", height: "100px", minWidth: 0 }}>
                        <div ref="booleanRawJsonAceHost" style={{ resize: "vertical", width: "97%", height: this.rawJsonEditorHeight, borderStyle: "solid", borderColor: "silver", borderWidth: "1px", padding: "5px", overflow: "auto", position: "relative" }}>
                            <AceEditor
                                editorId={'Editor_' + this.uniquekey}
                                lang="json"
                                onChangeContent={(text) => this.sync_json(text)}
                                content={rawjson}>
                            </AceEditor>
                        </div>
                    </td>

                </tr>
            );
        }

        if (this.readonly)
            input = (
                <input
                    type="text"
                    value={this.cmodel[this.schemakey]}
                    readonly
                    style={{ border: "none", backgroundColor: "unset", width: "100%", minWidth: 0, boxSizing: "border-box" }}
                />
            );
        else if (this.useexpressions) {
            input = (
                <QSelect style="min-width: 0"
                    outlined
                    dense
                    hide-bottom-space
                    use-input
                    emit-value
                    map-options
                    option-label="text"
                    option-value="value"
                    modelValue={this.cmodel[this.schemakey]}
                    options={booleanOptions}
                    onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />
            );
        }
        else {
            input = (
                <QSelect style="min-width: 0"
                    outlined
                    dense
                    hide-bottom-space
                    option-label="text"
                    option-value="value"
                    emit-value
                    map-options
                    modelValue={this.cmodel[this.schemakey]}
                    options={booleanOptions}
                    onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />
            );
        }

        return (
            <tr class="pa-0 ma-0">
                <td style={{ width: "1px" }}>
                    <span style={{ whiteSpace: "nowrap" }}>{name} {jsontgl} {desc}</span>
                </td>
                <td className="pa-0 ma-0" class={{ "property-grid": this.propertygrid }} style={this.propertygrid ? { minWidth: 0 } : undefined}>
                    {input}
                </td>
            </tr>
        );
    }
});